<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:500px;" class="mb-2 align-self-end">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="调度订单/订单编号/(ERP/WMS单号)/销售订单号搜索..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            v-allow="'actUnionDispatch'"
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="batchSchedulDispatch()"
          >
            <i class="el-icon-orange"></i>
            合并调度
          </b-button>
          <b-button
            v-allow="'actBatchDispatch'"
            size="sm"
            class="ml-2"
            variant="outline-primary"
            @click="batchDispatch()"
          >
            <i class="el-icon-s-promotion"></i>
            批量调度
          </b-button>
          <!-- <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="batchTransfer()"
          >
            <i class="el-icon-truck"></i>
            中转
          </b-button> -->
          <b-button
            v-allow="'actReturnOrder'"
            size="sm"
            variant="outline-danger"
            class="ml-2"
            @click="batchCancel()"
          >
            <i class="el-icon-refresh-left"></i>
            回退订单
          </b-button>
          <!-- <b-dropdown
            size="sm"
            variant="outline-success"
            class="ml-2"
            right
            text="汇总订单"
          >
            <template #button-content>
              <i class="el-icon-receiving"></i> 订单汇总
            </template>
            <b-dropdown-item @click="changeTable('customer')"
              >按客户汇总</b-dropdown-item
            >
            <b-dropdown-item @click="changeTable('point')"
              >按收发货方汇总</b-dropdown-item
            >
            <b-dropdown-item @click="changeTable('city')"
              >按城市汇总</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="changeTable('list')"
              >返回订单列表</b-dropdown-item
            >
          </b-dropdown> -->
        </b-input-group>
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="105px">
        <el-row :gutter="10">
          <!-- <el-col :span="24">
						<el-form-item label="创建日期">
							<el-date-picker
								v-model="form.setDateRange"
								type="datetimerange"
								:picker-options="pickerOptions"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								style="width:100%"
								size="small"
								:default-time="['00:00:00', '23:59:59']"
								:clearable="false"
							>
							</el-date-picker>
						</el-form-item>
					</el-col> -->
          <el-col :span="24">
            <el-form-item label="订单编号">
              <el-input
                v-model="form.orderNo"
                placeholder="请输入订单编号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="客户名称">
              <dict-select
                style="width:100%"
                v-model="form.custCode"
                filterable
                url="/master/customer/info/select"
                placeholder="请选择客户"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ERP/WMS单号">
              <el-input
                v-model="form.bizBillNo"
                placeholder="请输入ERP/WMS单号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="销售订单号">
              <el-input
                v-model="form.orderSoNo"
                placeholder="请输入销售订单号"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发货方">
              <el-input
                v-model="form.pickupPointName"
                placeholder="请输入发货方"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发货城市">
              <el-input
                v-model="form.pickupCityName"
                placeholder="请输入发货城市"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货方">
              <el-input
                v-model="form.receivePointName"
                placeholder="请输入收货方"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="收货城市">
              <el-input
                v-model="form.receiveCityName"
                placeholder="请输入收货城市"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单类型">
              <dict-select
                clearable
                v-model="form.orderType"
                placeholder="请选择订单类型"
                default
                filterable
                :body="orderTypeDictParams"
              >
              </dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog"
          >取消查询</el-button
        >
        <el-button size="small" type="warning" @click="reset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="advquery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import util from '@/libs/util'
// 初始表单
const initForm = {
  keyword: '',
  dispatchOrderStatusList: ['N'],
  timeType: '1',
  setDateRange: [],
  dispatchOrderStatusMode: 'N',
}
export default {
  data() {
    return {
      //订单类型下拉请求参数
      orderTypeDictParams: { type: 'orderType' },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              let startDate = util.formatDate(start, 'begin')
              let endDate = util.formatDate(end, 'end')
              picker.$emit('pick', [startDate, endDate])
            },
          },
        ],
      },
      form: { ...initForm },
      advqueryDialogVisible: false,
    }
  },
  created() {
    this.resetTime()
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
      this.resetTime()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    resetTime() {
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      let startDate = util.formatDate(start, 'begin')
      let endDate = util.formatDate(new Date(), 'end')
      this.form.setDateRange = [startDate, endDate]
    },
    batchDispatch() {
      this.$emit('batchDispatch')
    },
    batchSchedulDispatch() {
      this.$emit('batchSchedulDispatch')
    },
    batchTransfer() {
      this.$emit('batchTransfer')
    },
    batchCancel() {
      this.$emit('batchCancel')
    },
    changeTable(type) {
      this.$emit('changeTable', type)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.mt-2p {
  margin-top: 2px;
}
.line {
  text-align: center;
}
</style>
